module.exports = __webpack_public_path__ + "img/making-3.13285890.jpg";